import * as types from './Push.types';

const initialState = {
  pushMessages: [],
};

const push = (state = initialState, action) => {
  let messages = [];
  switch (action.type) {
    case types.PUSH_MESSAGE_RECEIVED:
      if (state.pushMessages.findIndex((m) => m.id === action.data.id) !== -1) {
        return state;
      }
      messages = state.pushMessages.slice(0, 100);
      messages.unshift(action.data);
      return Object.assign({}, state, { pushMessages: messages });
    case types.PUSH_MESSAGE_VIEWED:
      messages = state.pushMessages.slice(0, 100);
      messages.forEach((m) => (m.Viewed |= m.id == action.id));
      return Object.assign({}, state, { pushMessages: messages });
    default:
      return state;
  }
};

export default push;
